<div class="container_dati_generali">
  <div class="container_tab_nav" *ngIf="scadenze != null && scadenze.length > 0">
    <ul class="nav nav-tabs four">
      <li *ngFor="let tipoScadenza of tipiScadenzeTabs" [style.width.%]="100 / tipiScadenzeTabs.length"
        class="{{currentTab === tipoScadenza.id ? 'active' : 'inactive'}}" id="ts-{{ tipoScadenza.id }}"
        data-toggle="tab" (click)="filterScadenza(tipoScadenza.id)">
        <a>{{ tipoScadenza.label }}</a>
      </li>
    </ul>
    <div class="tab-content tab-pane fade in active">
      <ul class="att_completare">
        <li *ngFor="let scadenza of scadenzeFiltrate; let i = index">
          <div class="tipo_adempimento">
            <ng-template [ngIf]="scadenza.tipoScadenza.id != '3'">
              <p class="{{
                  (scadenza.tipoScadenza?.descrizione | lowercase) &&
                  (scadenza.tipoScadenza?.descrizione | lowercase).indexOf(
                    'attivit'
                  ) == 0
                    ? 'attivita'
                    : (scadenza.tipoScadenza?.descrizione | lowercase)
                }}">
                {{ scadenza.tipoScadenza?.label }}
                <span class="glyphicon glyphicon-exclamation-sign" [ngClass]="{
                    red: scadenza.priorita?.label == 'ALTA',
                    yellow: scadenza.priorita?.label == 'MEDIA',
                    green: scadenza.priorita?.label == 'BASSA'
                  }"></span>
                <span class="{{ scadenza.priorita?.label | lowercase }}">{{
                  scadenza.priorita?.label
                  }}</span>
                <span style="display: block">{{ scadenza.motivo?.label }}</span>
              </p>
            </ng-template>

            <div class="data_opzioni scadenze">
              <ul>
                <ng-template [ngIf]="!scadenza.evasa && scadenza.giorniRitardo">
                  <li class="stato_scadenze inevasa">inevasa</li>
                </ng-template>
                <ng-template [ngIf]="!scadenza.evasa && !scadenza.giorniRitardo">
                  <li class="stato_scadenze da_evadere">da evadere</li>
                </ng-template>
                <ng-template [ngIf]="scadenza.evasa">
                  <li class="stato_scadenze evasa">evasa</li>
                </ng-template>
                <li>
                  {{
                  (scadenza.lastRinvioScadenza
                  ? scadenza.lastRinvioScadenza.dataA
                  : scadenza.dataScadenza
                  ) | dateformatter : "DD/MM/YYYY HH:mm"
                  }}
                </li>
                <!--<li>
                  <span
                    [ngClass]="{
                      glyphicon: true,
                      'glyphicon-menu-down': !acc.isExpanded(
                        'adempimentolistmember' + i
                      ),
                      'glyphicon-menu-up': acc.isExpanded(
                        'adempimentolistmember' + i
                      )
                    }"
                    style="cursor: pointer"
                    (click)="acc.toggle('adempimentolistmember' + i)"
                  ></span>
                  <span
                    [ngClass]="{
                      glyphicon: true,
                      'glyphicon-trash': true
                    }"
                    style="cursor: pointer"
                    (click)="disassocia(scadenza)"
                  ></span>
                </li>-->
                <span
                  [ngClass]="{
                    glyphicon: true,
                    'glyphicon-trash': true
                  }"
                  style="cursor: pointer; margin-top: 10px"
                  (click)="disassocia(scadenza)"
                ></span>
                <a data-toggle="collapse" aria-expanded="true" (click)="openDetail(scadenza, i)"
                  [attr.aria-controls]="'subcontroparteModalAdd' + i" data-parent="#controparticollapse"
                  class="{{activeIndex === i ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"><span>Apri</span></a>
              </ul>
            </div>
          </div>

          <div *ngIf="scadenza.appunto && scadenza.appunto.trim().length > 0" class="documento white">
            <p>{{ scadenza.appunto }}</p>
          </div>


          <!--<ngb-accordion [closeOthers]="true" #acc="ngbAccordion">
            <ngb-panel id="adempimentolistmember{{ i }}">
              <ng-template ngbPanelContent>
                <div class="row">
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Tipo'"
                    [valueInput]="scadenza.tipoScadenza?.label"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Adempimento'"
                    [valueInput]="scadenza.motivo?.label"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Priorit&agrave;'"
                    [valueInput]="scadenza.priorita?.label"
                  ></div>
                </div>
                <div class="row">
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'dateTime'"
                    [labelInput]="'Data'"
                    [valueInput]="
                      scadenza.lastRinvioScadenza
                        ? scadenza.lastRinvioScadenza.dataA
                        : scadenza.dataScadenza
                    "
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'date'"
                    [labelInput]="'Data promemoria'"
                    [valueInput]="scadenza.dataPromemoria"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'boolean'"
                    [labelInput]="'Pubblica'"
                    [valueInput]="scadenza.pubblica"
                  ></div>
                </div>
                <div class="row">
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'boolean'"
                    [labelInput]="'Evaso'"
                    [valueInput]="scadenza.evasa"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'date'"
                    [labelInput]="'Data evasione'"
                    [valueInput]="scadenza.dataEvasione"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Appunto'"
                    [valueInput]="scadenza.appunto"
                  ></div>
                </div>
                <div class="row">
                  <div class="col-sm-12 bloccodati">
                    <p>
                      <label class="col-sm-12">Note</label>
                      <span class="longtext">{{ scadenza.note }}</span>
                    </p>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>-->
          <ul class="{{activeIndex === i ? 'collapsed' : 'collapse'}} subcontroparte">
            <li>
              <div class="row">
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo'"
                  [valueInput]="scadenza.tipoScadenza?.label"></div>
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Adempimento'"
                  [valueInput]="scadenza.motivo?.label"></div>
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Priorit&agrave;'"
                  [valueInput]="scadenza.priorita?.label"></div>
              </div>
              <div class="row">
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'dateTime'" [labelInput]="'Data'"
                  [valueInput]="
                    scadenza.lastRinvioScadenza
                      ? scadenza.lastRinvioScadenza.dataA
                      : scadenza.dataScadenza
                  "></div>
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data promemoria'"
                  [valueInput]="scadenza.dataPromemoria"></div>
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Pubblica'"
                  [valueInput]="scadenza.pubblica"></div>
              </div>
              <div class="row">
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Evaso'"
                  [valueInput]="scadenza.evasa"></div>
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Motivo evasione'"
                  [valueInput]="scadenza.motivoEvasione?.descrizione"></div>
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'" [labelInput]="'Data evasione'"
                  [valueInput]="scadenza.dataEvasione"></div>
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Appunto'"
                  [valueInput]="scadenza.appunto"></div>
              </div>
              <div class="row">
                <div class="col-sm-12 bloccodati">
                  <p>
                    <label class="col-sm-12">Note</label>
                    <span class="longtext">{{ scadenza.note }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="tab-content" *ngIf="scadenze == null || scadenze.length == 0">
    <p>Nessun adempimento è stato ancora inserito.</p>
  </div>
</div>
